//@ts-nocheck
import React from "react";

const EmptyContent = () => {
  return <div>Not Found</div>;
};
export default EmptyContent;
